<template>
    <div>
        <div class="nibnut-editor" style="height: 100%;">
            <editor-menu-bar :editor="editor">
                <nav slot-scope="{ commands, isActive, getMarkAttrs }" class="uk-navbar nibnut-editor-toolbar">
                    <ul class="uk-navbar-nav">
                        <li :class="{'uk-active': isActive.heading({ level: 1 })}">
                            <a href @click.prevent="commands.heading({ level: 1 })">H1</a>
                        </li>
                        <li :class="{'uk-active': isActive.heading({ level: 2 })}">
                            <a href @click.prevent="commands.heading({ level: 2 })">H2</a>
                        </li>
                        <li :class="{'uk-active': isActive.heading({ level: 3 })}">
                            <a href @click.prevent="commands.heading({ level: 3 })">H3</a>
                        </li>

                        <li :class="{'uk-active': isActive.bold()}">
                            <a href @click.prevent="commands.bold"><open-icon glyph="bold" /></a>
                        </li>
                        <li :class="{'uk-active': isActive.italic()}">
                            <a href @click.prevent="commands.italic"><open-icon glyph="italic" /></a>
                        </li>
                        <li :class="{'uk-active': isActive.underline()}">
                            <a href @click.prevent="commands.underline"><open-icon glyph="underline" /></a>
                        </li>
                        <li :class="{'uk-active': isActive.strike()}">
                            <a href @click.prevent="commands.strike"><open-icon glyph="strikethrough" /></a>
                        </li>

                        <li :class="{'uk-active': isActive.bullet_list()}">
                            <a href @click.prevent="commands.bullet_list"><open-icon glyph="list-ul" /></a>
                        </li>

                        <li :class="{'uk-active': isActive.link()}">
                            <a href @click.prevent="link_edit(commands.link, getMarkAttrs('link'))"><open-icon glyph="link" /></a>
                        </li>

                        <li :class="{'uk-active': isActive.blockquote()}">
                            <a href @click.prevent="commands.blockquote"><open-icon glyph="quote-right" /></a>
                        </li>
                    </ul>
                </nav>
            </editor-menu-bar>
            <editor-content :editor="editor" class="nibnut-editor-content">
                <div slot="content">{{ value }}</div>
            </editor-content>
        </div>

        <modal-dialog
            id="link-editor"
            :show.sync="link_editing"
        >
            <form-input
                ref="link_editor"
                name="link_url"
                v-model="link_url"
                :required="false"
            />

            <template v-slot:footer>
                <base-button
                    class="uk-margin-small-right"
                    @click.native.prevent="link_stop_editing(false)"
                >
                    Cancel
                </base-button>
                <base-button
                    color="primary"
                    class="uk-margin-small-left"
                    @click.native.prevent="link_stop_editing(true)"
                >
                    Save
                </base-button>
            </template>
        </modal-dialog>
    </div>
</template>

<script type="text/javascript">
import {
    Editor,
    EditorMenuBar,
    EditorContent
} from "tiptap"
import {
    // Nodes
    Blockquote,
    HardBreak,
    Heading,

    // Marks
    Bold,
    Italic,
    Link,
    Strike,
    Underline,

    BulletList,
    // OrderedList,
    ListItem
} from "tiptap-extensions"
import ModalDialog from "../dialogs/ModalDialog/ModalDialog"
import FormInput from "./FormInput"
import BaseButton from "./BaseButton"
import OpenIcon from "./OpenIcon"

export default {
    name: "Editor",
    mounted () {
        this.editor = new Editor({
            extensions: [
                new Blockquote(),
                new HardBreak(),
                new Heading({ maxLevel: 3 }),
                new Bold(),
                new Italic(),
                new Link(),
                new Strike(),
                new Underline(),
                new BulletList(),
                new ListItem()
            ],
            onUpdate: ({ getHTML }) => {
                if(this.live) this.input_action(getHTML())
            },
            onBlur: ({ getHTML }) => {
                if(!this.live) this.input_action(this.editor.getHTML())
            }
        })
        this.editor.setContent(this.value)
    },
    beforeDestroy () {
        this.editor.destroy()
    },
    watch: {
        value (new_value) {
            if(new_value !== this.editor.getHTML()) this.editor.setContent(this.value, false)
        }
    },
    components: {
        EditorMenuBar,
        EditorContent,
        ModalDialog,
        FormInput,
        BaseButton,
        OpenIcon
    },
    methods: {
        /** Triggered when input changes
         * @event input
         * @type {Event}
         */
        input_action (html) {
            this.$emit("input", html)
        },
        link_edit (command, attrs) {
            this.link_save = command
            this.link_url = attrs.href
            this.link_editing = true
            this.$nextTick(() => {
                this.$refs.link_editor.$el.getElementsByTagName("input")[0].focus()
            })
        },
        link_stop_editing (save) {
            if(save) this.link_save({ href: this.link_url || null })
            this.link_stop_edit()
        },
        link_stop_edit () {
            this.link_save = null
            this.link_url = null
            this.link_editing = false
        }
    },
    props: {
        value: {
            type: String,
            default: ""
        },
        live: {
            type: Boolean,
            default: true
        }
    },
    data () {
        return {
            editor: null,

            link_save: null,
            link_url: null,
            link_editing: false
        }
    }
}
</script>
